import { Component, OnInit, OnDestroy } from "@angular/core";

import { DataService_ActionMaintenance } from "../shared/data.service";

import { wsActionMaintenanceActionGetDataParm } from "../shared/wsActionMaintenanceActionModifyInfo";
import { wsActionMaintenanceActionGetDataInfo } from "../shared/wsActionMaintenanceActionModifyInfo";
import { wsActionMaintenanceActionPenaltyTypeInfo } from "../shared/wsActionMaintenanceActionModifyInfo";
import { wsActionMaintenanceActionAlertInfo } from "../shared/wsActionMaintenanceActionModifyInfo";
import { wsActionMaintenanceActionGradeInfo } from "../shared/wsActionMaintenanceActionModifyInfo";

import { wsActionMaintenanceActionAddParm } from "../shared/wsActionMaintenanceActionModifyInfo";
import { wsActionMaintenanceActionUpdateParm } from "../shared/wsActionMaintenanceActionModifyInfo";
import { wsActionMaintenanceActionGradeParm } from "../shared/wsActionMaintenanceActionModifyInfo";

import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { Table } from "primeng/table";
import { Dropdown } from "primeng/dropdown";

@Component({
	selector: "app-root",
	templateUrl: "./addeditaction.component.html",
	styleUrls: ["./addeditaction.component.css"],
	providers: [ConfirmationService],
})
export class AddEditActionComponent implements OnInit, OnDestroy {
	constructor(
		private dataService: DataService_ActionMaintenance,
		public ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		public dialogConfig: DynamicDialogConfig
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	public isBusy: boolean = false;

	public UserID: number;
	public UserLevelID: number;
	public SchoolID: number = -1;
	public PenaltyID: number = -1;
	public isAdd: boolean = false;
	public isViewOnly: boolean = false;
	public isLimitedEdit: boolean = false;
	public selectedGroupValue: string = "2";

	public ActionData: wsActionMaintenanceActionGetDataInfo;

	public lstPenaltyTypeItems: wsActionMaintenanceActionPenaltyTypeInfo[] = [];
	public SelectedPenaltyType: wsActionMaintenanceActionPenaltyTypeInfo = {
		PenaltyTypeID: 3,
		PenaltyTypeDesc: "Normal",
	}; // For HTML to not error on init

	public lstAlertItemsFull: wsActionMaintenanceActionAlertInfo[] = [];
	public lstAlertItems: wsActionMaintenanceActionAlertInfo[] = [];
	public SelectedAlert: wsActionMaintenanceActionAlertInfo = {
		AlertID: -1,
		AlertDesc: "(NONE)",
		AlertSeverityID: -1,
		SoundLibraryID: -1,
		SoundFile: "",
		SoundData: "",
	}; // For HTML to not error on init

	public lstGradeItems: wsActionMaintenanceActionGradeInfo[] = [];
	public lstDistrictGradeItemsItems: wsActionMaintenanceActionGradeInfo[] = [];
	public lstSchoolGradeItems: wsActionMaintenanceActionGradeInfo[] = [];

	public isSelectAll: boolean = false;

	public rPenaltyCD: string = "";
	public rPenaltyDesc: string = "";
	public rMinDurationDayCount: number = 0;
	public rMaxDurationDayCount: number = 0;
	public rIsNotification: boolean = false;
	public rIsEDCRAssignable: boolean = false;

	//	DataTable page counts
	public pagefirst: number = 0;
	public pagerows: number = 10;

	public mp3Player: any = new Audio();

	public ErrorMessage: string = "";

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.isBusy = true;

		this.UserID = this.dialogConfig.data.UserID;
		this.UserLevelID = this.dialogConfig.data.UserLevelID;
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.PenaltyID = this.dialogConfig.data.PenaltyID;
		this.isAdd = this.dialogConfig.data.isAdd;

		let parm: wsActionMaintenanceActionGetDataParm = {
			UserID: this.UserID,
			SchoolID: this.SchoolID,
			PenaltyID: this.PenaltyID,
		};

		this.isBusy = true;
		this.dataService.ActionMaintenanceActionDataGet(parm).subscribe((data) => this.ActionMaintenanceActionDataGet_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceActionDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceActionDataGet_Complete(data: any) {
		this.ActionData = data;

		this.lstPenaltyTypeItems = this.ActionData.PenaltyTypeItems;
		this.lstAlertItemsFull = this.ActionData.AlertItems;
		this.lstDistrictGradeItemsItems = this.ActionData.DistrictGradeItems;
		this.lstSchoolGradeItems = this.ActionData.SchoolGradeItems;

		this.rPenaltyCD = this.ActionData.PenaltyCD;
		this.rPenaltyDesc = this.ActionData.PenaltyDesc;
		this.rMinDurationDayCount = this.ActionData.MinDurationDayCount;
		this.rMaxDurationDayCount = this.ActionData.MaxDurationDayCount;
		this.rIsNotification = this.ActionData.IsNotification;
		this.rIsEDCRAssignable = this.ActionData.IsEDCRAssignable;

		let tmpDefinedByID = this.ActionData.DefinedByID;

		if (this.isAdd == true) {
			//
			//	Add Mode
			//
			this.selectedGroupValue = "2"; // Current School Only (Default)
			this.isViewOnly = false;
			this.isLimitedEdit = false;
		} else {
			//
			//	Edit Mode
			//
			this.isViewOnly = false;
			this.isLimitedEdit = false;

			if (this.ActionData.SchoolID < 1) {
				//
				// All Schools
				//
				this.selectedGroupValue = "1"; // All Schools

				if (this.ActionData.DefinedByID == 1 || this.ActionData.DefinedByID == 2) {
					// System or Import
					if (this.UserLevelID == 1) {
						// District Level
						this.isLimitedEdit = true;
					} else {
						this.isViewOnly = true;
					}
				}

				if (this.ActionData.DefinedByID == 3 || this.ActionData.DefinedByID == 4) {
					// School or District
					if (this.UserLevelID == 3) {
						// School Level
						this.isViewOnly = true;
					}
				}
			} else {
				//
				//	Current School Only
				//
				this.selectedGroupValue = "2"; // Current School Only

				if (this.ActionData.DefinedByID == 1 || this.ActionData.DefinedByID == 2) {
					// System or Import
					if (this.UserLevelID == 1) {
						// District Level
						this.isLimitedEdit = true;
					} else {
						this.isViewOnly = true;
					}
				}

				if (this.ActionData.DefinedByID == 4) {
					// District
					if (this.UserLevelID == 3) {
						// School Level
						this.isViewOnly = true;
					}
				}
			}
		}

		//
		//	Select Default PenaltyType
		//
		this.SelectedPenaltyType = this.lstPenaltyTypeItems[0];

		this.lstPenaltyTypeItems.forEach((item) => {
			if (item.PenaltyTypeID == this.ActionData.PenaltyTypeID) {
				this.SelectedPenaltyType = item;
			}
		});

		//
		//	Select Default Alert
		//
		this.lstAlertItems = this.lstAlertItemsFull.filter((xx) => xx.AlertSeverityID === this.SelectedPenaltyType.PenaltyTypeID || xx.AlertSeverityID === -1);
		this.SelectedAlert = this.lstAlertItems[0];

		this.lstAlertItems.forEach((item) => {
			if (item.AlertID == this.ActionData.AlertID) {
				this.SelectedAlert = item;
			}
		});

		//
		//	Set Grade List
		//
		if (this.selectedGroupValue == "1") {
			// All Schools
			this.lstGradeItems = this.lstDistrictGradeItemsItems;
		} else {
			this.lstGradeItems = this.lstSchoolGradeItems;
		}

		this.isBusy = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		if (this.selectedGroupValue == "1") {
			// All Schools
			this.lstGradeItems = this.lstDistrictGradeItemsItems;
		} else {
			this.lstGradeItems = this.lstSchoolGradeItems;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPenaltyTypeChange
	//
	//-----------------------------------------------------------------------------------------------------
	onPenaltyTypeChange(value) {
		this.lstAlertItems = this.lstAlertItemsFull.filter((xx) => xx.AlertSeverityID === this.SelectedPenaltyType.PenaltyTypeID || xx.AlertSeverityID === -1);
		this.SelectedAlert = this.lstAlertItems[0];

		this.lstAlertItems.forEach((item) => {
			if (item.AlertID == this.ActionData.AlertID) {
				this.SelectedAlert = item;
			}
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAlertChange
	//
	//-----------------------------------------------------------------------------------------------------
	onAlertChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSoundChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSoundChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPlay
	//
	//-----------------------------------------------------------------------------------------------------
	onPlay() {
		if (this.SelectedAlert.SoundLibraryID > 0) {
			this.mp3Player.pause(); // First, Try to stop any playing files
			this.mp3Player = new Audio(this.SelectedAlert.SoundData);
			this.mp3Player.play();
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onStop
	//
	//-----------------------------------------------------------------------------------------------------
	onStop() {
		this.mp3Player.pause();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onHandleSort
	//
	//-----------------------------------------------------------------------------------------------------
	onHandleSort(e: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSelectAll
	//
	//-----------------------------------------------------------------------------------------------------
	onSelectAll(e: any) {
		if (this.selectedGroupValue == "1") {
			// All Schools
			this.lstDistrictGradeItemsItems.forEach((item) => {
				if (this.isSelectAll == true) {
					item.isSelected = true;
				} else {
					item.isSelected = false;
				}
			});
		} else {
			this.lstSchoolGradeItems.forEach((item) => {
				if (this.isSelectAll == true) {
					item.isSelected = true;
				} else {
					item.isSelected = false;
				}
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAddUpdate
	//
	//-----------------------------------------------------------------------------------------------------
	onAddUpdate() {
		this.ErrorMessage = "";

		//
		// Validate
		//
		if (this.rPenaltyCD.length < 1) {
			this.ErrorMessage = "Code must be entered.";
			return;
		}

		if (this.rPenaltyDesc.length < 1) {
			this.ErrorMessage = "Description must be entered.";
			return;
		}

		if (this.SelectedPenaltyType.PenaltyTypeID != 3) {
			// 1=Suspension or 2=In-House Suspension
			if (isNaN(Number(this.rMinDurationDayCount))) {
				this.ErrorMessage = "Min duration days is not a number.";
				return;
			}

			if (isNaN(Number(this.rMaxDurationDayCount))) {
				this.ErrorMessage = "Max duration days is not a number.";
				return;
			}

			if (Number(this.rMinDurationDayCount < 1)) {
				this.ErrorMessage = "Min duration days must be greater than 0.";
				return;
			}

			if (Number(this.rMinDurationDayCount) > Number(this.rMaxDurationDayCount)) {
				this.ErrorMessage = "Min duration days cannot be greater than Max duration days.";
				return;
			}

			if (this.SelectedAlert.AlertID < 1) {
				this.ErrorMessage = "You must select an Alert for this action type.";
				return;
			}
		}

		//
		//	Validations Passed, Do the Insert or Update
		//
		if (this.PenaltyID < 1) {
			//
			//	INSERT
			//
			let lstGradeItems: wsActionMaintenanceActionGradeParm[] = [];
			let parmSchoolID: number;

			if (this.selectedGroupValue == "1") {
				// All Schools
				parmSchoolID = -1;

				this.lstDistrictGradeItemsItems.forEach((item) => {
					lstGradeItems.push({
						GradeLevelID: item.GradeLevelID,
						isSelected: item.isSelected,
					});
				});
			} else {
				parmSchoolID = this.SchoolID; // current school

				this.lstSchoolGradeItems.forEach((item) => {
					lstGradeItems.push({
						GradeLevelID: item.GradeLevelID,
						isSelected: item.isSelected,
					});
				});
			}

			let parm: wsActionMaintenanceActionAddParm = {
				PenaltyCD: this.rPenaltyCD,
				PenaltyDesc: this.rPenaltyDesc,
				PenaltyTypeID: this.SelectedPenaltyType.PenaltyTypeID,
				MinDurationDayCount: this.rMinDurationDayCount,
				MaxDurationDayCount: this.rMaxDurationDayCount,
				AlertID: this.SelectedAlert.AlertID,
				IsNotification: this.rIsNotification,
				IsEDCRAssignable: this.rIsEDCRAssignable,
				SchoolID: parmSchoolID,
				GradeItems: lstGradeItems,
			};

			this.isBusy = true;
			this.dataService.ActionMaintenanceActionAdd(parm).subscribe((data) => this.ActionMaintenanceActionAdd_Complete(data));
		} else {
			//
			//	UPDATE
			//
			let lstGradeItems: wsActionMaintenanceActionGradeParm[] = [];

			if (this.selectedGroupValue == "1") {
				// All Schools
				this.lstDistrictGradeItemsItems.forEach((item) => {
					lstGradeItems.push({
						GradeLevelID: item.GradeLevelID,
						isSelected: item.isSelected,
					});
				});
			} else {
				this.lstSchoolGradeItems.forEach((item) => {
					lstGradeItems.push({
						GradeLevelID: item.GradeLevelID,
						isSelected: item.isSelected,
					});
				});
			}

			let parm: wsActionMaintenanceActionUpdateParm = {
				PenaltyID: this.PenaltyID,
				PenaltyCD: this.rPenaltyCD,
				PenaltyDesc: this.rPenaltyDesc,
				PenaltyTypeID: this.SelectedPenaltyType.PenaltyTypeID,
				MinDurationDayCount: this.rMinDurationDayCount,
				MaxDurationDayCount: this.rMaxDurationDayCount,
				AlertID: this.SelectedAlert.AlertID,
				IsNotification: this.rIsNotification,
				IsEDCRAssignable: this.rIsEDCRAssignable,
				GradeItems: lstGradeItems,
			};

			this.isBusy = true;
			this.dataService.ActionMaintenanceActionUpdate(parm).subscribe((data) => this.ActionMaintenanceActionUpdate_Complete(data));
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceActionAdd_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceActionAdd_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ActionMaintenanceActionUpdate_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ActionMaintenanceActionUpdate_Complete(data: any) {
		this.isBusy = false;
		this.ErrorMessage = data[0];

		//
		// 0 = CANCEL; 1 = SAVE
		//
		if (this.ErrorMessage.length == 0) {
			this.ref.close(1);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onClose
	//
	//-----------------------------------------------------------------------------------------------------
	onClose() {
		//
		// 0 = CANCEL; 1 = SAVE
		//
		this.ref.close(0);
	}
}
